import { useEffect } from 'react'
import { useUnreadCounts } from './useUnreadCounts'
import { useNotificationStore } from '@/stores/notificationStore'

/**
 * 앱 아이콘 배지 — 안 읽은 채팅 + 미읽은 알림 합산 표시
 * navigator.setAppBadge API (Android PWA, Chrome 등)
 */
export function useAppBadge() {
  const chatCounts = useUnreadCounts()
  const notifUnread = useNotificationStore((s) => s.notifications.filter((n) => !n.read).length)

  useEffect(() => {
    if (!('setAppBadge' in navigator)) return

    const chatTotal = Object.values(chatCounts).reduce((sum, c) => sum + c, 0)
    const total = chatTotal + notifUnread

    if (total > 0) {
      navigator.setAppBadge(total).catch(() => {})
    } else {
      navigator.clearAppBadge?.().catch(() => {})
    }
  }, [chatCounts, notifUnread])
}
